import script from "./amodalPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./amodalPayment.vue?vue&type=script&setup=true&lang=js"

import "./amodalPayment.vue?vue&type=style&index=0&id=ab29d682&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab29d682"]])

export default __exports__